import React from 'react';
import { ArrowDownUp } from 'lucide-react';
import { cn } from '../lib/utils';
import { useLocale } from '../contexts/LocaleContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

export type ResourcesSortOption =
  | 'name_asc'
  | 'created_desc'
  | 'created_asc'
  | 'reference_date_desc'
  | 'reference_date_asc';

interface ResourcesSortMenuProps {
  value: ResourcesSortOption;
  onChange: (value: ResourcesSortOption) => void;
  className?: string;
}

export const ResourcesSortMenu: React.FC<ResourcesSortMenuProps> = ({ value, onChange, className }) => {
  const { t } = useLocale();

  const options: { value: ResourcesSortOption; label: string }[] = [
    { value: 'name_asc', label: t('sort_by_name') },
    { value: 'created_desc', label: t('sort_most_recent') },
    { value: 'created_asc', label: t('sort_oldest') },
    { value: 'reference_date_desc', label: t('sort_reference_date_recent') },
    { value: 'reference_date_asc', label: t('sort_reference_date_oldest') },
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={t('sort_button_label')}
          title={t('sort_button_label')}
          className={cn(
            'flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-md border border-input bg-card text-muted-foreground shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground',
            className
          )}
        >
          <ArrowDownUp className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[240px] p-2">
        <DropdownMenuRadioGroup value={value} onValueChange={(next) => onChange(next as ResourcesSortOption)}>
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
